import { render, staticRenderFns } from "./ProductReviews.vue?vue&type=template&id=43058c16&lang=pug&"
import script from "./ProductReviews.vue?vue&type=script&lang=js&"
export * from "./ProductReviews.vue?vue&type=script&lang=js&"
import style0 from "./ProductReviews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43058c16')) {
      api.createRecord('43058c16', component.options)
    } else {
      api.reload('43058c16', component.options)
    }
    module.hot.accept("./ProductReviews.vue?vue&type=template&id=43058c16&lang=pug&", function () {
      api.rerender('43058c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/bourdain/ProductReviews.vue"
export default component.exports